import { memo, useMemo } from 'react';
import { Box, Icon, Text } from '@betty/moonlight';
import { aggregateRewards } from './PromoRewards.utils';
import { PROMO_REWARDS_CONFIG } from './PromoRewards.constants';
import { PromoRewardsProps } from './PromoRewards.types';

function PromoRewards({ rewards }: PromoRewardsProps) {
  const aggregatedRewards = useMemo(() => aggregateRewards(rewards), [rewards]);

  return (
    <Box flexDirection="row" gap="space-200">
      {aggregatedRewards.map(({ type, amount }) => {
        const config = PROMO_REWARDS_CONFIG[type];

        if (!config) {
          return null;
        }

        return (
          <Box key={type} flexDirection="row" gap="space-100" centerContent>
            <Icon
              name={config.icon}
              gradient="accentBackground"
              width="space-400"
              height="space-400"
            />
            <Text variant="body-s" color="darkSurfacePrimary">
              {amount}
            </Text>
          </Box>
        );
      })}
    </Box>
  );
}

export default memo(PromoRewards);
